// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    createHorizontalSmallHeadingAndTextStyles,
    createVerticalSmallHeadingAndTextStyles,
} from "@conklin/App/SharedStyles/SmallHeadingAndTextStyles";
import { productCarouselStyles } from "@conklin/Overrides/Widgets/Common/ProductCarousel";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { ellipsis, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

productCarouselStyles.errorMessageText = {
    color: "danger",
    css: css`
        margin-top: 20px;
    `,
};
productCarouselStyles.titleText = {
    variant: "h2",
    forwardAs: "p",
};
productCarouselStyles.swiper = {
    container: {
        css: css`
            .swiper-wrapper {
                @media print {
                    display: flex !important;
                }
            }
        `,
    },
};
productCarouselStyles.dataWrapper = {
    css: css`
        ${({ displayAsGrid }: any) => {
            if (displayAsGrid) {
                return css`
                    display: grid;
                    grid-template-columns: minmax(0, 1fr) 243px;
                    grid-column-gap: 22px;
                    ${xScreen("lte", "lg")} {
                        grid-template-columns: minmax(0, 1fr) 204px;
                    }
                    ${xScreen("lte", "md")} {
                        grid-template-columns: minmax(0, 1fr) 232px;
                        grid-column-gap: 20px;
                    }

                    ${xScreen("lte", "sm")} {
                        display: flex;
                        flex-direction: column;
                        row-gap: 20px;
                        padding-bottom: 24px;
                    }
                    ${xScreen("lte", "xs")} {
                        .swiper-slide {
                            max-width: 180px;
                        }
                    }
                `;
            }
        }}
    `,
};
productCarouselStyles.boxWrapper = {
    container: {
        css: css`
            width: 100%;
        `,
    },
};
productCarouselStyles.smallHeadingAndTextItems = {
    ...createHorizontalSmallHeadingAndTextStyles({
        heading: {
            size: 14,
            css: css`
                line-height: 17px;
            `,
        },
        text: {
            size: 14,
            css: css`
                line-height: 17px;
            `,
        },
    }),
};
productCarouselStyles.smallHeadingAndTextPrice = {
    ...createVerticalSmallHeadingAndTextStyles({
        heading: {
            size: 14,
            css: css`
                line-height: 17px;
            `,
        },
        text: {
            size: 20,
            weight: fontConfig.weight.black,
            css: css`
                line-height: 24px;
            `,
        },
    }),
};
productCarouselStyles.carouselWrapper = {
    css: css`
        ${({ carouselType }: any) => {
            if (carouselType === "relatedProducts") {
                return css`
                    ${xScreen("lte", "sm")} {
                        .swiper-slide {
                            width: auto;
                        }
                    }
                `;
            }
            if (carouselType === "recentlyViewed") {
                return css`
                    ${xScreen("lte", "sm")} {
                        .swiper-slide {
                            width: 204px;
                        }
                    }
                `;
            }
        }}
    `,
};
productCarouselStyles.box = {
    container: {
        css: css`
            display: flex;
            flex-direction: column;
            row-gap: 12px;
        `,
    },
};
productCarouselStyles.addToCartButton = {
    sizeVariant: "small",
    css: css`
        width: 100%;
    `,
};
productCarouselStyles.checkBox = {
    css: css`
        position: absolute;
        top: 8px;
        left: 8px;
    `,
};
productCarouselStyles.carouselProductStyles = {
    productDescriptionStyles: {
        productDetailLink: {
            typographyProps: {
                css: css`
                    ${ellipsis(3)}
                `,
            },
        },
        productDetailDescription: {
            css: css`
                ${ellipsis(3)}
            `,
        },
    },
};
